export const LOGOS = {
  show: "/brand/show.webp",
  familia: "/brand/familia.webp",
  games: "/brand/games.webp",
};

export const PDF_URL = "/brand/apresentacao-pedro-clube-show.pdf";
export const PDF_FILENAME = "Midia-Kit-Pedro-Clube-Show.pdf";

export const CONTACT = {
  email: "diegocrepes@gmail.com",
  phone: "(51) 9876-7765",
  whatsapp: `https://wa.me/555198767765?text=${encodeURIComponent(
    "Olá Diego e Dani! Vim pelo site do Pedro Clube Show e quero conversar sobre uma parceria.",
  )}`,
  mailto: `mailto:diegocrepes@gmail.com?subject=${encodeURIComponent("Parceria - Pedro Clube Show")}`,
};

export const SOCIAL = {
  ytShow: "https://www.youtube.com/@pedroclubeshow",
  ytFamilia: "https://www.youtube.com/@familiapedroclubeshow",
  ytGames: "https://www.youtube.com/@pedroclubegames",
  igShow: "https://www.instagram.com/pedroclubeshow/",
  igFamilia: "https://www.instagram.com/familiapedroclubeshow/",
};

export const NAV = [
  { label: "Canais", id: "#canais" },
  { label: "Sobre", id: "#sobre" },
  { label: "Mídia Kit", id: "#midia-kit" },
  { label: "Destaques", id: "#destaques" },
  { label: "Parcerias", id: "#parcerias" },
];

export const MARQUEE = [
  "Músicas infantis autorais",
  "Vlogs de viagens em família",
  "490 mil+ visualizações",
  "Tudo em apenas 4 meses",
  "90,8% assistem pela TV",
  "Entretenimento seguro",
  "Parceria ganha-ganha",
  "De norte a sul do Brasil",
];

export const YT_CHANNELS = [
  {
    key: "familiapedroclubeshow",
    title: "Família Pedro Clube Show",
    handle: "@familiapedroclubeshow",
    tag: "Vlogs de viagens & família",
    text: "Vlogs reais de passeios, viagens e rotina familiar.",
    logo: LOGOS.familia,
    href: SOCIAL.ytFamilia,
    color: "green",
    stats: [
      { v: "458+", l: "Inscritos" },
      { v: "310 mil", l: "Visualizações" },
      { v: "+15 mil", l: "Horas de exibição" },
    ],
  },
  {
    key: "pedroclubeshow",
    title: "Pedro Clube Show",
    handle: "@pedroclubeshow",
    tag: "Músicas infantis",
    text: "Músicas autorais e lúdicas infantis, com clipes animados.",
    logo: LOGOS.show,
    href: SOCIAL.ytShow,
    color: "blue",
    stats: [
      { v: "210", l: "Inscritos" },
      { v: "180 mil", l: "Visualizações" },
      { v: "5.100", l: "Horas de exibição" },
    ],
  },
];

export const IG_CHANNELS = [
  { key: "familiapedroclubeshow", handle: "@familiapedroclubeshow", href: SOCIAL.igFamilia, tag: "Dia a dia da família" },
  { key: "pedroclubeshow", handle: "@pedroclubeshow", href: SOCIAL.igShow, tag: "Músicas & novidades" },
];

export const FAMILY = [
  { key: "diego", name: "Diego", role: "Papai · Publicitário", color: "var(--blue)" },
  { key: "dani", name: "Dani", role: "Mamãe · Administradora", color: "var(--green)" },
  { key: "pedro", name: "Pedro", role: "A estrela do show", color: "var(--red)" },
];

export const PHOTOS = { familia: "/brand/familia-foto.webp", pedro: "/brand/pedro-foto.webp" };
export const CITY = "Porto Alegre, RS";

export const TOTALS = [
  { v: "490 mil+", l: "visualizações somadas" },
  { v: "20 mil+", l: "horas assistidas" },
  { v: "668+", l: "inscritos no YouTube" },
];

export const AUDIENCE = [
  { key: "tv", big: "90,8%", title: "A sala de estar é o nosso palco", text: "Assistem pela TV, junto com a família." },
  { key: "female", big: "62%", title: "O poder das mães", text: "Público feminino, com mães de 25 a 44 anos como principais decisoras." },
  { key: "brasil", big: "87–95%", title: "Público brasileiro", text: "Audiência massivamente brasileira, de norte a sul do país." },
];

export const HIGHLIGHTS = [
  {
    key: "vlogs",
    label: "Vlogs em família",
    channel: "@familiapedroclubeshow",
    puffy: "puffy-green",
    videos: [
      { key: "aventura-jurassica", title: "Aventura Jurássica", img: "/brand/yt-aventura-jurassica.webp", href: "https://youtu.be/3w5h1J4tBV4", tint: "var(--green)" },
      { key: "oceanic-aquarium", title: "Oceanic Aquarium", img: "/brand/yt-oceanic-aquarium.webp", href: "https://youtu.be/61UCbK6Ltus", tint: "var(--blue)" },
      { key: "big-land", title: "Big Land em Porto Alegre", img: "/brand/yt-big-land.webp", href: "https://youtu.be/nk_8JfZPVEs", tint: "var(--red)" },
    ],
  },
  {
    key: "musicas",
    label: "Músicas",
    channel: "@pedroclubeshow",
    puffy: "puffy-blue",
    videos: [
      { key: "brasil-na-copa", title: "Brasil na Copa", img: "/brand/yt-brasil-na-copa.webp", href: "https://youtu.be/MH22wvcrtxo", tint: "var(--yellow)" },
      { key: "hotwheels", title: "Hot Wheels na Imaginação", img: "/brand/yt-hotwheels.webp", href: "https://youtu.be/D1Oz1dAoh7k", tint: "var(--blue)" },
      { key: "fazendinha", title: "Fazendinha do Pedrinho", img: "/brand/yt-fazendinha.webp", href: "https://youtu.be/hWITIi5aVdo", tint: "var(--green)" },
    ],
  },
];

export const PARTNERSHIP = [
  {
    key: "oferecemos",
    kicker: "O que oferecemos",
    title: "Divulgação espontânea & real",
    text: "Vlogs completos e envolventes no YouTube e cobertura dinâmica no Instagram, mostrando o seu espaço de forma natural e atemporal para atrair famílias interessadas.",
    color: "var(--blue)",
  },
  {
    key: "solicitamos",
    kicker: "O que solicitamos",
    title: "Acesso & apoio local",
    text: "Sem pagamento ou cachê. Pedimos cortesias/entradas para a família, um tour guiado se possível e apoio para captar as melhores cenas e detalhes.",
    color: "var(--green)",
  },
  {
    key: "contrapartida",
    kicker: "A contrapartida",
    title: "Crescimento mútuo",
    text: "O parceiro compartilha e reposta o conteúdo nos seus canais oficiais: material rico de divulgação para a marca e mais alcance para nós.",
    color: "var(--red)",
  },
];
